module.exports = __webpack_public_path__ + "static/media/dashboard.9ecc4875.svg";